var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.389 60.471a6.01 6.01 0 0 1-4.5-2.1 3.9 3.9 0 0 0-6.225 0 5.854 5.854 0 0 1-8.992 0 3.9 3.9 0 0 0-6.223 0 5.853 5.853 0 0 1-8.991 0 3.9 3.9 0 0 0-6.218 0 6 6 0 0 1-4.5 2.1 6 6 0 0 1-4.495-2.1 4.055 4.055 0 0 0-3.109-1.547v-2a6 6 0 0 1 4.5 2.1 4.057 4.057 0 0 0 3.109 1.547 4.053 4.053 0 0 0 3.109-1.547 5.852 5.852 0 0 1 8.99 0 3.9 3.9 0 0 0 6.22 0 5.855 5.855 0 0 1 8.993 0 3.9 3.9 0 0 0 6.222 0 5.856 5.856 0 0 1 8.994 0 3.907 3.907 0 0 0 6.227 0 6.007 6.007 0 0 1 4.5-2.1v2a4.062 4.062 0 0 0-3.113 1.547 6.01 6.01 0 0 1-4.498 2.1zM26.7 5.086c9.8-.736 10.458 9.967 10.458 9.967s-8.579-7.19-17.811-.409c-.002 0-.335-8.982 7.353-9.558z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.988 5.086c-9.8-.736-10.457 9.967-10.457 9.967s8.578-7.19 17.81-.409c0 0 .333-8.982-7.353-9.558z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.392 16.249c-5.523 8.133 3.43 14.033 3.43 14.033s-1.958-11.02 8.521-15.645c0 0-7.621-4.764-11.951 1.612zM31.3 16.249c5.523 8.133-3.431 14.033-3.431 14.033s1.959-11.02-8.521-15.645c-.005 0 7.617-4.764 11.952 1.612zM8.022 55.481c.875.84 1.082.99 1.725.99s.85-.15 1.724-.989a7.823 7.823 0 0 1 11.759 0c.876.84 1.083.99 1.726.99s.85-.15 1.725-.989a7.825 7.825 0 0 1 11.762 0c.876.839 1.083.989 1.727.989s.851-.15 1.726-.989a7.827 7.827 0 0 1 11.762 0c.879.841 1.086.991 1.731.991s.851-.15 1.727-.989c.182-.175.4-.373.623-.576-4.993-6.764-14.386-11.33-25.167-11.33S12.4 48.142 7.4 54.908c.23.202.441.399.622.573z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.141 33.033h-3.652v-2h2.774a33.385 33.385 0 0 1-2.607-16.056l-2.153-.6A37.627 37.627 0 0 0 17.332 39.1h4.26v2h-3.576c.361.951.773 1.908 1.243 2.869a37.528 37.528 0 0 1 10.072-2.244 52.326 52.326 0 0 1-5.19-8.692z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsland);
export default __webpack_public_path__ + "static/media/island.da4c2c143935fa5c01675cef2e20e45c.svg";
export { ForwardRef as ReactComponent };